import { BadgeCheck, MapPin } from "lucide-react";
import { Crumbs } from "../product/ProductHero";
import { QuoteButton } from "../home/CtaButtons";
import { imageUrl } from "../../lib/api";
import { categoryLabel, projectOnderwerp } from "../../data/portfolio";

export const ProjectHero = ({ p, crumbs }) => {
  const meta = [p.plaats, p.year, p.woningtype].filter(Boolean);
  return (
    <section aria-labelledby="project-title" className="relative overflow-hidden border-b border-slate-200 bg-white" data-testid="project-hero">
      <div className="hero-grid absolute inset-y-0 right-0 hidden w-[50%] lg:block" aria-hidden="true" />
      <div className="container-tight relative grid items-center gap-10 pb-12 pt-6 sm:pt-8 lg:grid-cols-12 lg:gap-12 lg:pb-16">
        <div className="reveal lg:col-span-6">
          <Crumbs items={crumbs} />
          <p className="eyebrow mt-6">Uitgevoerd project{p.categories?.length ? ` · ${p.categories.map(categoryLabel).join(" · ")}` : ""}</p>
          <h1 id="project-title" className="h1 mt-3 text-balance lg:text-[2.5rem]" data-testid="project-title">{p.title}</h1>
          {meta.length > 0 && (
            <p className="mt-4 flex items-center gap-2 text-[15px] font-medium text-slate-600" data-testid="project-meta">
              <MapPin className="h-4 w-4 text-maas" aria-hidden="true" /> {meta.join(" · ")}
            </p>
          )}
          {p.summary && <p className="lead mt-4 max-w-xl">{p.summary}</p>}
          <QuoteButton location="project-hero" onderwerp={projectOnderwerp(p)} params={{ project: p.slug }} className="mt-7 sm:self-start"
            label="Ontvang een prijsindicatie voor vergelijkbare kozijnen" />
        </div>
        <div className="reveal relative lg:col-span-6 [animation-delay:120ms]">
          <div className="frame">
            <img src={imageUrl(p.hero_image?.path)} alt={p.hero_image?.alt || p.title} fetchPriority="high" className="aspect-[4/3] w-full rounded-[14px] object-cover sm:aspect-[3/2]" data-testid="project-hero-image" />
          </div>
          <div className="card absolute -bottom-6 left-4 flex max-w-[300px] items-center gap-3 p-4 pr-5 sm:left-8" style={{ boxShadow: "var(--shadow-2)" }}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-maas-soft text-maas"><BadgeCheck className="h-5 w-5" aria-hidden="true" /></span>
            <div><p className="text-[15px] font-semibold text-ink">Uitgevoerd door Maas Kozijn</p><p className="text-[13px] text-slate-500">Echte foto's van dit project</p></div>
          </div>
        </div>
      </div>
    </section>
  );
};
